// NotificationsPage.js
import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from 'react-router-dom';

const NotificationsPage = ({ notifications, markAsRead }) => {
  const navigate = useNavigate();

  const handleClick = (notif) => {
    if (!notif.isRead) markAsRead(notif._id);
    navigate(notif.link);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Notifications
      </Typography>
      <List>
        {notifications.map((notif) => (
          <React.Fragment key={notif._id}>
            <ListItem
              button
              onClick={() => handleClick(notif)}
              sx={{
                backgroundColor: notif.isRead ? 'inherit' : '#e3f2fd', // Light blue for unread
                fontWeight: notif.isRead ? 'normal' : 'bold',
              }}
              secondaryAction={
                !notif.isRead && (
                  <IconButton edge="end" onClick={() => markAsRead(notif._id)}>
                    <DoneIcon />
                  </IconButton>
                )
              }
            >
              <ListItemText
                primary={
                  <Typography
                    sx={{ fontWeight: notif.isRead ? 'normal' : 'bold' }}
                  >
                    {notif.message}
                  </Typography>
                }
                secondary={new Date(notif.createdAt).toLocaleString()}
              />
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </>
  );
};

export default NotificationsPage;
